export const importToolMapCodesConstant: ReadonlyMap<string | undefined, string | undefined> = new Map<string, string>()
  .set('entry.error.product.identifier.unknown', 'dpUploadFromCSV.entry.error.product.identifier.unknown')
  .set('entry.error.invalid', 'dpUploadFromCSV.entry.error.invalid')
  .set('entry.error.add', 'dpUploadFromCSV.entry.error.add')
  .set('entry.error.product.notAllowed', 'dpUploadFromCSV.entry.error.product.notAllowed')
  .set('success.quantity.updated', 'dpUploadFromCSV.success.quantity.updated')
  .set('entry.error.connectedCode.notNumber', 'dpUploadFromCSV.entry.error.connectedCode')
  .set('entry.error.connectedCode.notInRange', 'dpUploadFromCSV.entry.error.connectedCode')
  .set('entry.error.openText.tooLong', 'dpUploadFromCSV.entry.error.openText')
  .set('entry.error.partNumber.tooLong', 'dpUploadFromCSV.entry.error.partNumber')
  .set('fail.quantity.updated.no.stock', 'dpUploadFromCSV.entry.error.noStock')
  .set('entry.error.product.generic', 'dpAddEntry.error.generic');
